const state = {}

const mutations = {}

function getParentWindowOrigin() {
  try {
    if (document.referrer) return new URL(document.referrer).origin
  } catch {
    // Fall back to the configured origin when the referrer is unavailable or invalid.
  }

  return process.env.VUE_APP_PARENT_WINDOW_URL
}

function postToParent(message) {
  window.parent.postMessage(message, getParentWindowOrigin())
}

const actions = {
  postDeleteMessage() {
    postToParent({ type: 'delete-session', message: 'delete-session' })
  },
  sendLoadedFlag() {
    postToParent({ type: 'live-editor-loaded' })
  },
  sessionExpired({}, message = 'Editing time has expired. You can edit live seats for up to 24 hours.') {
    postToParent({ type: 'session-expired', message: message })
  },
  cancelLiveEditing() {
    postToParent({ type: 'cancel-live-editing' })
  },
  publish() {
    postToParent({ type: 'publish' })
  },
  socialPublishing() {
    postToParent({ type: 'social-publishing' })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
